/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_EyebrowInputs */

const en_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Range`)
};

const es_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El campo`)
};

const de_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Range`)
};

const zh_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场`)
};

const ar_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الميدان`)
};

const fr_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le practice`)
};

const vi_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân tập`)
};

const sw_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwanja wa mazoezi`)
};

const th_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟ`)
};

const bs_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbalište`)
};

const ja_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライビングレンジ`)
};

const ko_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지`)
};

const pt_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O driving range`)
};

const it_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const sv_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range`)
};

const nl_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const da_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range`)
};

const nb_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangen`)
};

const fi_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoitusalue`)
};

const pl_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const ru_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драйвинг-рейндж`)
};

const tr_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const hi_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंज`)
};

const id_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const ms_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapang Latihan`)
};

const cs_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const el_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const he_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מגרש האימונים`)
};

const af_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die oefenbaan`)
};

const hu_range_eyebrow = /** @type {(inputs: Range_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

/**
* | output |
* | --- |
* | "The Range" |
*
* @param {Range_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_eyebrow = /** @type {((inputs?: Range_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_eyebrow(inputs)
	if (locale === "de") return de_range_eyebrow(inputs)
	if (locale === "zh") return zh_range_eyebrow(inputs)
	if (locale === "ar") return ar_range_eyebrow(inputs)
	if (locale === "fr") return fr_range_eyebrow(inputs)
	if (locale === "vi") return vi_range_eyebrow(inputs)
	if (locale === "sw") return sw_range_eyebrow(inputs)
	if (locale === "th") return th_range_eyebrow(inputs)
	if (locale === "bs") return bs_range_eyebrow(inputs)
	if (locale === "ja") return ja_range_eyebrow(inputs)
	if (locale === "ko") return ko_range_eyebrow(inputs)
	if (locale === "pt") return pt_range_eyebrow(inputs)
	if (locale === "it") return it_range_eyebrow(inputs)
	if (locale === "sv") return sv_range_eyebrow(inputs)
	if (locale === "nl") return nl_range_eyebrow(inputs)
	if (locale === "da") return da_range_eyebrow(inputs)
	if (locale === "nb") return nb_range_eyebrow(inputs)
	if (locale === "fi") return fi_range_eyebrow(inputs)
	if (locale === "pl") return pl_range_eyebrow(inputs)
	if (locale === "ru") return ru_range_eyebrow(inputs)
	if (locale === "tr") return tr_range_eyebrow(inputs)
	if (locale === "hi") return hi_range_eyebrow(inputs)
	if (locale === "id") return id_range_eyebrow(inputs)
	if (locale === "ms") return ms_range_eyebrow(inputs)
	if (locale === "cs") return cs_range_eyebrow(inputs)
	if (locale === "el") return el_range_eyebrow(inputs)
	if (locale === "he") return he_range_eyebrow(inputs)
	if (locale === "af") return af_range_eyebrow(inputs)
	if (locale === "hu") return hu_range_eyebrow(inputs)
	return en_range_eyebrow(inputs)
});